<div class="dropdownSelect__cont">
  <div class="dropdownSelect__input-field">
    <app-ds-drop-down-field
      [type]="dropDownFieldType"
      [fieldIsFailed]="showError"
      [fieldPlaceholder]="defaultSelection"
      [fieldFailedType]="fieldFailedType"
      [dropDownListOptions]="dropDownDsOptions"
      [fieldStaticFilled]="true"
      [fieldIsFilled]="inputIsFilled"
      [fieldLabel]="inputLabel"
      [dropDownListSelected]="dropDownListSelected"
      [dropDownListSearchInput]="withSearchInput"
      [dropDownListSearchInputPlaceholder]="inputPlaceholder"
      [infiniteScrollDisabled]="false"
      [isDisabled]="disabledOptionList"
      (selectEvent)="selectDropDownFieldDsEvent($event)"
      (fieldEvent)="toggleShowOptions()">
    </app-ds-drop-down-field>
  </div>
  
  <ng-container *ngIf="isMobile">
    <div class="dropdownSelect__swipe" [class.full-height]="fullHeight" [class.active]="showOptions" [class.empty]="dropDownDsOptions?.length === 0">
      <ng-container *ngIf="showTitle">
        <div class="dropdownSelect__title">
          <app-ds-typography
            [text]="title"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.SemiBold"
            [tag]="'h2'"
            [size]="fontSize.XS">
          </app-ds-typography>
        </div>
      </ng-container>
      <div class="dropdownSelect__list" [class.search]="withSearchInput" *ngIf="showOptions">
        <app-ds-drop-down-list
          [type]="dropDownListType.Embedded"
          [selectedBy]="dropDownListSelectedBy.RadioButton"
          [options]="dropDownDsOptions"
          [selectedId]="dropDownListSelected?.Id"
          [searchInput]="withSearchInput"
          [searchInputPlaceholder]="inputPlaceholder"
          [resetSearch]="showOptions"
          [infiniteScrollDisabled]="infiniteScrollDisabled"
          [borderRadius]="withSearchInput ? swipeBorderRadius : null"
          (selectEvent)="selectDropDownDsEvent($event)">
        </app-ds-drop-down-list>
      </div>
    </div>
    <div class="dropdownSelect__modal-bg" [class.children-ages]="inChildrenAges" (click)="toggleShowOptions()" [class.active]="showOptions" [class.in-swipe-up]="inSwipeUp"></div>
  </ng-container>
</div>
